import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { BrightnessAutoOutlined, DarkModeOutlined, LightModeOutlined } from '@mui/icons-material';
import { THEME_AUTOMATIC, THEME_LIGHT } from 'envConfig';
import { ThemePreference, normalizeThemePreference } from 'theme/themeMode';

interface ThemeModeToggleProps {
  preference?: string | null;
  onCycle: () => void;
}

const LABELS: Record<ThemePreference, string> = {
  light: 'Light',
  dark: 'Dark',
  automatic: 'Automatic',
};

const NEXT_LABELS: Record<ThemePreference, string> = {
  light: 'Dark',
  dark: 'Automatic',
  automatic: 'Light',
};

export const ThemeModeToggle: React.FC<ThemeModeToggleProps> = ({ preference, onCycle }) => {
  const pref = normalizeThemePreference(preference);
  const title = pref === THEME_AUTOMATIC
    ? 'Theme: Automatic (follows system). Click for Light'
    : `Theme: ${LABELS[pref]}. Click for ${NEXT_LABELS[pref]}`;

  return (
    <Tooltip title={title}>
      <IconButton onClick={onCycle} aria-label={title}>
        {pref === THEME_LIGHT ? (
          <LightModeOutlined sx={{ fontSize: '25px' }} />
        ) : pref === THEME_AUTOMATIC ? (
          <BrightnessAutoOutlined sx={{ fontSize: '25px' }} />
        ) : (
          <DarkModeOutlined sx={{ fontSize: '25px' }} />
        )}
      </IconButton>
    </Tooltip>
  );
};

export default ThemeModeToggle;
